import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  CenterExceptionalExpense,
  CenterExceptionalExpensesFilter
} from '../../../lib/types/models/center/center-exceptional-expenses'
import { encodeNestedObject } from '../../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export function getCenterExceptionalExpenses(
  id: number,
  query: PaginationRequest<CenterExceptionalExpensesFilter> = {}
) {
  return restApiClient
    .url(
      encodeNestedObject(
        constructApiUrl(API.centers.getCenterExceptionalExpenses.url, { id }),
        query
      )
    )
    .get<PaginationResponse<CenterExceptionalExpense>>()
}
